import React from "react";
import "./NumbersSection.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

function NumbersSection({ machineSupply, clinics, experience, support }) {
  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger animation once
    threshold: 0.3, // 30% of the element should be visible to trigger
  });

  return (
    <div className="numbers-container" ref={ref}>
      <div className="numbers-content">
        <div className="machinesupply">
          <p className="numbers-section">
            {inView && (
              <>
                <CountUp end={parseInt(machineSupply)} duration={2} />
                {typeof machineSupply === "string" &&
                  machineSupply.includes("+") &&
                  "+"}
              </>
            )}
          </p>
          <p className="numbers-desc">
            MEDICAL MACHINE <br /> SUPPLIED
          </p>
        </div>
        <div className="clinics">
          <p className="numbers-section">
            {inView && (
              <>
                <CountUp end={parseInt(clinics)} duration={2} />
                {typeof clinics === "string" && clinics.includes("+") && "+"}
              </>
            )}
          </p>
          <p className="numbers-desc">
            HOSPITALS & CLINICS <br /> EQUIPPED
          </p>
        </div>
        <div className="experience">
          <p className="numbers-section">
            {inView && (
              <>
                <CountUp end={parseInt(experience)} duration={2} />
                {typeof experience === "string" &&
                  experience.includes("+") &&
                  "+"}
              </>
            )}
          </p>
          <p className="numbers-desc">
            YEARS OF <br /> EXPERIENCE
          </p>
        </div>
        <div className="support">
          <p className="numbers-section">{support}</p>
          <p className="numbers-desc">
            DEDICATED CUSTOMER <br /> SUPPORT
          </p>
        </div>
      </div>
    </div>
  );
}

export default NumbersSection;
